import { getStringHidden } from '../../../views/ganttContainer/gantt/gantt.helper';
import { isColumnVisibleByDefault } from '../../../utils/partialPermissionUtils';
import { columnCache } from '../../../services/columnCache';

const calendarIdCol = (gantt, t) => ({
  name: 'calendar_id',
  label: 'Calendario',
  align: 'center',
  width: '*',
  template: (activity) => {
    if (gantt.calendarOptions) {
      if (activity.calendar_id) {
        const hasChild = gantt.hasChild(activity.id);
        let isOdd = false;
        if (gantt.oddColsConfig) {
          isOdd = gantt.oddColsConfig.calendar_id;
        }

        const dCal = gantt.calendarOptions.find(
          (cal) => cal.key == activity.calendar_id
        );
        const htmlH = getStringHidden(
          dCal ? dCal.label : 'None',
          'calendar_id'
        );
        let retStr =
          '<div class="' +
          (isOdd ? 'odd-col' : 'non-odd-col') +
          '" style="' +
          (hasChild ? 'font-weight: 600' : 'font-weight: 100') +
          '">';
        retStr = `${retStr}
                        <span class="string-v">${dCal ? dCal.label : 'None'}</span>
                        ${htmlH}
                    </div>
                    `;
        return retStr;
      }
    }
  },
  resize: true,
  editor: {
    type: 'select',
    map_to: 'calendar_id',
    options: []
  },
  hide: !isColumnVisibleByDefault('calendar_id'),
  data_type: 'array/string',
  from_values: [],
  groupable: false,
  groupable_switch: ['1 → N', 'N → 1'],
  orderable: true,
  orderable_switch: ['1 → N', 'N → 1'],
  filterable: true
});

export default calendarIdCol; 